import { render, staticRenderFns } from "./MessagesTable.vue?vue&type=template&id=175a8ad4"
import script from "./MessagesTable.vue?vue&type=script&lang=js"
export * from "./MessagesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports